import { api, ApiError, prefetch } from './api';
import { h, main } from './dom';
import { lockup } from './logo';
import { returnTo, setMe, type Me } from './me';
import { applyPrefs } from './settings';
import { renderSignIn } from './signin';

applyPrefs();

async function boot() {
  const story = /^\/t\/(\d{1,9})$/.exec(location.pathname);
  // The screen's code is known from the address alone: fetch it while we ask who's signed in, not after.
  const screen = story ? import('./table') : import('./app');
  screen.catch(() => {});
  // …and its first data.
  if (/(?:^|; )infinidie_in=1/.test(document.cookie))
    for (const u of story ? [`/api/tables/${story[1]}`] : ['/api/campaign', '/api/genres', '/api/tables', '/api/campaigns']) prefetch(u);
  try {
    const me = await api<Me>('GET', '/api/me');
    setMe(me);
    if (story) { const { renderTable } = await (screen as Promise<typeof import('./table')>); await renderTable(me, Number(story[1])); return; }
    const { renderApp } = await (screen as Promise<typeof import('./app')>);
    await renderApp(me);
  } catch (e) {
    if (e instanceof ApiError && e.status === 401) {
      if (story) returnTo.set(location.pathname);
      renderSignIn(story ? 'Sign in to join your friend’s story. We’ll bring you straight back here.' : undefined);
    } else main().replaceChildren(h('h1', { class: 'brand-hero' }, lockup().el), h('p', { role: 'alert' }, (e as Error).message), h('a', { href: '/', class: 'primary' }, 'Try again'));
  }
}
void boot();
